import Button from "@material-ui/core/Button";
import React from "react";


export default function StyledButton(props) {
    return (
        <Button
            {...props.buttonProps}
        >
            {props.label}
        </Button>
    )
}